import React, { useState } from "react";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";
import CoreInputField from "../../../../app/core/components/CoreInputField/CoreInputField";
import { useEditDocumentMutation } from "../../../api/user/gestisciDocumentiApi";
import { toast } from "react-toastify";
import { t } from "i18next";
import CoreTextArea from "../../../../app/core/components/CoreTextArea/CoreTextArea";
import CoreMaxCharacter from "../../../../app/core/components/CoreMaxCharacter/CoreMaxCharacter";

const EditNameDoc = ({ document, close }) => {
  const [formData, setFormData] = useState({
    name: document.name,
    notes: document.notes,
  });
  const [editDocument, { isLoading: isEditingDocument }] =
    useEditDocumentMutation();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleEditDoc = () => {
    const bodyDoc = {
      categoryId: document.categoryId,
      id: document.id,
      name: formData.name,
      scope: document.scope,
      notes: formData.notes,
    };
    editDocument(bodyDoc)
      .then((res) => {
        close();
        toast.success(t("DocEdited"));
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  return (
    <div className="container text-center space-y-8">
      <h3>{t("Edit") + " " + t("document")}</h3>
      <div className="flex flex-col justify-center gap-6">
        <CoreInputField
          name="name"
          label={t("DocName")}
          value={formData.name}
          onChange={handleInputChange}
        />
        <div className="flex items-center">
          <CoreTextArea
            rows={3}
            name="notes"
            label={t("Notes")}
            className={"w-full"}
            value={formData.notes}
            onChange={handleInputChange}
            error={formData.notes?.length > 250}
          />
          <CoreMaxCharacter maxCharacter={250} text={formData.notes} />
        </div>
      </div>
      <CoreButton
        disabled={
          isEditingDocument ||
          !formData?.name?.trim() ||
          formData.notes?.length > 250
        }
        className="btn-round"
        testo={isEditingDocument ? t("Wait") : t("Edit")}
        onClick={handleEditDoc}
      />
    </div>
  );
};

export default EditNameDoc;
